import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useCounterShift(branchId, counterId) {
  return useQuery({
    queryKey: ["counter-shift", branchId, counterId],
    queryFn: async () => {
      const { data } = await api.get("/counter-sessions/current", {
        params: { branch_id: branchId, counter_id: counterId },
      });
      return data;
    },
    enabled: Boolean(branchId && counterId),
    staleTime: 30_000,
  });
}
